import {Form} from 'antd';
import {FormInstance} from 'antd/es/form';
import {NamePath} from 'antd/es/form/interface';
import React, {forwardRef, useState} from 'react';

import {CustomFieldsInputs} from 'components/report-configuration/tabs/report-table-settings/components/report-table-custom-fields/custom-fields-inputs/custom-fields-inputs';
import {TStateSetter} from 'shared/types/generics';
import {TCustomColumnType} from 'store/slices/report-configuration-slice/report-configuration-dto';

interface IReportTableCustomFieldsProps {
    form: FormInstance;
    isDisabled: boolean;
    name: NamePath;
    isHidden?: boolean;
    hiddenFields: Record<string, boolean>;
    setHiddenFields: TStateSetter<Record<string, boolean>>;
    isCustomColumnsDisplaying: boolean;
    setCustomColumnsDisplaying: TStateSetter<boolean>;
}

export const ReportTableCustomFields = forwardRef(({
    form,
    isDisabled,
    name,
    isHidden,
    hiddenFields,
    setHiddenFields,
    isCustomColumnsDisplaying,
    setCustomColumnsDisplaying,
}: IReportTableCustomFieldsProps, ref) => {
    const [columnsTypes, setColumnsTypes] = useState<Record<string, TCustomColumnType | undefined>>({});

    return (
        <Form.List name={name}>
            {(fields, operations, {errors}) => (
                <CustomFieldsInputs
                    ref={ref}
                    form={form}
                    fields={fields}
                    operations={operations}
                    errors={errors}
                    isHidden={isHidden}
                    isDisabled={isDisabled}
                    hiddenFields={hiddenFields}
                    setHiddenFields={setHiddenFields}
                    columnsTypes={columnsTypes}
                    setColumnsTypes={setColumnsTypes}
                    isCustomColumnsDisplaying={isCustomColumnsDisplaying}
                    setCustomColumnsDisplaying={setCustomColumnsDisplaying}
                />
            )}
        </Form.List>
    );
});
